var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.game.hasInstructions)?_c('instruction-list',{attrs:{"current-instruction":_vm.currentPlayer.currentInstruction},on:{"finishGame":_vm.finishGame}}):_vm._e(),_c('div',{staticClass:"ma-5 text-center",class:{
      'locked-tangram': _vm.isLockedTangram,
      'reduced-svg-size': _vm.game.hasInstructions,
    },domProps:{"innerHTML":_vm._s(_vm.initialTangram)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }